import { FAQ } from '@/components/UI/FAQ'

export default function FrequentlyAskedQuestions() {
  return (
    <div className="py-16">
      <h1 className="mx-auto max-w-4xl text-center text-5xl font-bold tracking-tight">
        FAQ
      </h1>
      <FAQ />
    </div>
  )
}
